/* import __COLOCATED_TEMPLATE__ from './cash.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();